import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { BuscarService } from 'src/app/services/buscar.service';
import { objClienteFrm } from 'src/app/modulos/archivos/interlocutor-comercial/cliente/cliente-nuevo/objConfiguracionCliente.model'
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { Cliente } from 'src/app/models/cliente.model';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ClienteService } from 'src/app/services/cliente.service'
import { VendedorService } from 'src/app/services/vendedor.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { RecursosService } from 'src/app/services/recursos.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportarDniComponent } from '../../importar-dni/importar-dni.component';
import { ModificarClienteComponent } from '../modificar-cliente/modificar-cliente.component';

@Component({
  selector: 'app-nuevo-cliente',
  templateUrl: './nuevo-cliente.component.html',
  styleUrls: ['./nuevo-cliente.component.css']
})
export class NuevoClienteComponent implements OnInit {


  @ViewChild('selectInsertar') selectInsertar: ElementRef;
  @ViewChild('selectModificar') selectModificar: ElementRef;
  @ViewChild(NuevoClienteComponent) tableclases: NuevoClienteComponent | any;

  //Vista - tipo -> 1 lista , 2 nuevo , 3 modificar 
  vista: number = 1;
  identidad: boolean = true;
  isnatural: boolean = true;
  tamanoidentidad: number;
  //Objeto para guardar 
  objCliente = new objClienteFrm();
  public _sunatImage: any = {};
  public ParamDocumento = new Cliente();
  //llamar a servicios combo
  identidades: any = []
  vendedores: any = []
  titulolista: any = []
  tipopersona: any = []
  clienteRegimenes: any = []

  ClaseTemp = new ClienteClase()


  public clasesSelect: any[] = [];

  disabledCodigosClaseCombo: boolean = true;

  public disabledGuardar: boolean = true;
  clientes: any = [];
  clases = [];
  listaclases = [];
  listacodigos = [];
  closeResult = '';

  //Variables para el modal new clase
  inputclase: any;
  desputclase: any;
  valorclase: any;

  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;

  editinputcla: any;
  editinputdescla: any;
  editinputcodigo: any;
  editinputdescodigo: any;
  editclase: any;
  tident: string = '';

  public _recursos: any = {};
  sessionInfo: any;
  disable_codigo: any = false;

  constructor(
    private clienteService: ClienteService,
    private _buscarService: BuscarService,
    private spinnerService: SpinnerService,
    private VendedorService: VendedorService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private recursosService: RecursosService,
    private toastr: ToastrService,
    private router: Router,
    private modalService2: NgbActiveModal,

  ) { 
    
  }

  ngOnInit(): void {

    this.objCliente.valident = true;

    this.spinnerService.activarLoading(true);
    this.recursosService.recursosIC().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
      this._recursos = resp.body;
      if (this._recursos != null && this._recursos.personas != null)
        this.tipopersona = this._recursos.personas;
      if (this._recursos != null && this._recursos.identidades != null)
        this.identidades = this._recursos.identidades;
      if (this._recursos != null && this._recursos.vendedores != null) {
        this.vendedores = this._recursos.vendedores;
        if (this.vendedores.length > 0)
          this.objCliente.codven = this.vendedores[0].codven;
      }

      if (this._recursos != null && this._recursos.tituloListas != null) {
        this.titulolista = this._recursos.tituloListas;
        this.objCliente.codtit = this.titulolista[0].codtit;
      }

      if (this._recursos != null && this._recursos.impositivos != null) {
        this.clienteRegimenes = this._recursos.impositivos;
        if (this.clienteRegimenes.length > 0) {
          this.objCliente.regret = this.clienteRegimenes[0].codigo;
        }
      }


      this.obtenerClases();
      this.obtenerListaClases();
      //this.obtenerClientes();

      //Variables por defecto
      this.objCliente.codtpe = 1
      this.tident = "06"

      this.isnatural = true
      this.objCliente.sexo = 'M'
      this.objCliente.tident = '01'
      this.identidad = false
      this.tamanoidentidad = 8

      this.sessionInfo = JSON.parse(StorageService.getSession());
      if (this.sessionInfo.factores.codigoClienteAutomatico != null &&
        this.sessionInfo.factores.codigoClienteAutomatico == true) {
        this.disable_codigo = true;
      }

      this.onNexFocus('Insert')

    }, err => {
      this.spinnerService.activarLoading(false);
    });

  }




  obtenerClases() {
    this.clienteService.buscarClasesObligatotias().subscribe(response => {
      this.clases = response.body;
    })
  }

  obtenerListaClases() {
    this.clienteService.buscarClases().subscribe(response => {
      this.listaclases = response.body;
    })
  }

  obtenerListaClasesCodigos(clase: any) {
    this.clienteService.buscarCodigos(clase).subscribe(response => {
      this.listacodigos = response.body;
      this.codCodigoClase = this.listacodigos[0].codigo
      this.spinnerService.activarLoading(false)
    })
  }

  onChangeClases(clase: any) {
    this.spinnerService.activarLoading(true)
    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    this.obtenerListaClasesCodigos(clase);
  }


  closeInsert() {
    this.borrarDatosInset();
  }

  borrarDatosInset() {
    //this.disabledBotonClases = true;
    this.disabledCodigosClaseCombo = true;
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = null;
    this.desCodigoClase = '';
    //this.childModalClases.hide();
  }





  importarDatosSunat() {
    const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static', windowClass: 'md-importar-sunat'});
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.dni = this.objCliente.dident;
    referenciaModal.result.then((data) => {

      this.objCliente.codtpe = 2;
      this.objCliente.tident = '06';
      this.objCliente.dident = data.ruc;
      this.tident = "999999"
      this.objCliente.codcli = data.ruc;
      this.objCliente.direc1 = data.direc.substring(0, 95);
      this.objCliente.razonc = data.razonc.substring(0, 75);
      this.onSelectTipoIdentidadIns(this.objCliente.tident)
      this.identidades.forEach(element => {
        if (element.tident == this.objCliente.tident) {
          console.log(element)
          this.tamanoidentidad = element.tamano;
        }
      });
    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });
  }

 importarDatosDNI() {
    const referenciaModal = this.modalService.open(ImportarDniComponent, { scrollable: true, backdrop: 'static', windowClass: 'md-importar-sunat'});
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.dni = this.objCliente.dident;
    referenciaModal.result.then((data) => {

      this.objCliente.codtpe = 1; // 1
      this.objCliente.tident = '01'; //01
      this.tident = "06"
      this.objCliente.dident = data.ruc;
      this.objCliente.codcli = data.ruc;
      this.objCliente.direc1 = data.direc.substring(0, 95);
      this.objCliente.razonc = data.razonc.substring(0, 75);
      this.onSelectTipoIdentidadIns(this.objCliente.tident)
      this.identidades.forEach(element => {
        if (element.tident == this.objCliente.tident) {
          console.log(element)
          this.tamanoidentidad = element.tamano;
        }
      });
    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });
  }

  numerodident = 0;

  guardarCliente() {

    if (this.objCliente.dident == null || this.objCliente.dident == '' || this.objCliente.dident == undefined) {
      this.numerodident = 0;
    }
    else {
      this.numerodident = this.objCliente.dident.toString().length;
    }
    if (this.objCliente.tident.toString() == '06' || this.objCliente.tident.toString() == '01') {
      if (this.tamanoidentidad != 0 && (this.objCliente.dident == null)) {
        basicAlert('El campo "Doc. de identidad" es requerido y debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }

    if (this.objCliente.tident.toString() == '06' || this.objCliente.tident.toString() == '01') {
      if (this.tamanoidentidad != 0 && this.numerodident != this.tamanoidentidad) {
        basicAlert('El campo "Doc. de identidad" debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }
    if (this.tident != "06" && (this.objCliente.razonc == '' || this.objCliente.razonc == null)) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Razón social" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.tident == "06" && (this.objCliente.razonc == '' || this.objCliente.razonc == null)) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Apellidos y nombres" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objCliente.codven == null || this.objCliente.codven < 0) {
      basicAlert('El campo "vendedor" es obligatorio.', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objCliente.codtit == null || this.objCliente.codtit <= 0) {
      basicAlert(' El título de lista es obligatorio.', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objCliente.regret == null || this.objCliente.regret < 0) {
      basicAlert(' El concepto impositivo es obligatorio.', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objCliente.codtpe == 2 && (this.objCliente.direc1 == '' || this.objCliente.direc1 == null)) {
      basicAlert('El campo "Dirección 1" es obligatorio y mayor a 10 dígitos.', 'warning', 'Aceptar', null, null);
      return;
    }




    this.identidades.forEach(element => {
      if (element.tident == this.objCliente.tident) {
        this.objCliente.tidentNombre = element.descri;
      }
    });

    this.tipopersona.forEach(element => {
      if (element.codtpe == this.objCliente.codtpe) {
        this.objCliente.tipopersona = element.destpe;
      }
    });

    this.titulolista.forEach(element => {
      if (element.codtit == this.objCliente.codtit) {
        this.objCliente.titulolista = element.titulo;
      }
    });


    this.ParamDocumento.id_cia = this.objCliente.id_cia;
    this.ParamDocumento.tipopersona = this.objCliente.tipopersona;
    this.ParamDocumento.valident = this.objCliente.valident;
    this.ParamDocumento.tident = this.objCliente.tident;
    this.ParamDocumento.codcli = this.objCliente.codcli;
    this.ParamDocumento.nombrescompletos = this.objCliente.nombrescompletos;
    this.ParamDocumento.direc1 = (this.objCliente.direc1 != undefined && this.objCliente.direc1 != null && this.objCliente.direc1.length > 0) ? this.objCliente.direc1.trim() : "";
    this.ParamDocumento.direc2 = (this.objCliente.direc2 != undefined && this.objCliente.direc2 != null && this.objCliente.direc2.length > 0) ? this.objCliente.direc2.trim() : "";
    this.ParamDocumento.apellidopaterno = this.objCliente.apellidopaterno;
    this.ParamDocumento.email = this.objCliente.email;
    this.ParamDocumento.apeliidomaterno = this.objCliente.apeliidomaterno;
    this.ParamDocumento.telefono = this.objCliente.telefono;
    this.ParamDocumento.nombres = this.objCliente.nombres;
    this.ParamDocumento.fax = this.objCliente.fax;
    this.ParamDocumento.nrodni = this.objCliente.nrodni;
    this.ParamDocumento.sexo = this.objCliente.sexo;
    this.ParamDocumento.titulolista = this.objCliente.titulolista;
    this.ParamDocumento.codven = this.objCliente.codven;
    this.ParamDocumento.exoimp = this.objCliente.exoimp;
    this.ParamDocumento.regret = this.objCliente.regret;
    this.ParamDocumento.observ = this.objCliente.observ;
    this.ParamDocumento.codtit = this.objCliente.codtit;
    this.ParamDocumento.codtpe = this.objCliente.codtpe;
    this.ParamDocumento.razonc = this.objCliente.razonc.trim();
    this.ParamDocumento.dident = this.objCliente.dident;
    this.ParamDocumento.fecing = moment(this.objCliente.fecing).format("YYYY-MM-DD");
    this.ParamDocumento.activo = true;
    this.ParamDocumento.clases = this.clases;
    this.ParamDocumento.codpag = 1;


    this.spinnerService.activarLoading(true);
    this.clienteService.insertCliente(this.ParamDocumento).subscribe((response: any) => {
      console.log(response);
      let codigo = this.ParamDocumento.codcli
      this.toastr.success('Se registró correctamente.','',{ positionClass: 'toast-bottom-left'})
      this.ParamDocumento = new Cliente();
      this.borrarDatos();
      this.spinnerService.activarLoading(false);
      //this.buscar();
      this.vista = 1
      this.cerrar();
      timerOut(200).then((value: any) => {
        if (value) { 
          console.log(this.objCliente)
        const referenciaModal = this.modalService.open(ModificarClienteComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
      referenciaModal.componentInstance.codcli = codigo;
        }
      })

        }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
     
      if (err.status >= 500) {
        basicAlert(err.error, 'error', 'Aceptar');
      } else {
        if(err.status ==400){
          basicAlert(err.error, 'error', 'Aceptar');
        }else{
          basicAlert(err.error.message, 'warning', 'Aceptar');
          this.vista = 1
          this.cerrar();
        }
      
      }
    })
  }



  cancelarInsercion() {
    this.cerrar();
  }

  borrarDatos() {
    this.objCliente = new objClienteFrm();
    this.disabledGuardar = true;
    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");


    setTimeout(() => {
      $('#codTipoDocumento').focus();
    }, 150);
  }

  onNexFocus(tipo: string) {
    if (tipo == 'Insert') {
      timerOut(10).then((value: any) => {
        if (value) { this.selectInsertar.nativeElement.focus(); }
      })
    } else {
      timerOut(10).then((value: any) => {
        if (value) { this.selectModificar.nativeElement.focus(); }
      })
    }
  }

  public messageTable = {
    emptyMessage: 'No hay información',
    totalMessage: 'total',
    selectedMessage: 'selected'
  }

  open1(content1: string, tipo: string) {
    if (tipo == 'clase') {
      this.codClase = this.listaclases[0].codigo
      this.onChangeClases(this.codClase)
    }
    this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  guardarClase() {
    //obteniendo la descripcion de la clase en desClase
    this.listaclases.forEach(element => {
      if (element.codigo == this.codClase) {
        console.log(element)
        this.desClase = element.descri;
      }
    });
    //obteniendo la descripcion del codigo en desCodigoClase
    this.listacodigos.forEach(element => {
      if (element.codigo == this.codCodigoClase) {
        console.log(element)
        this.desCodigoClase = element.descri;
      }
    });

    this.ClaseTemp = new ClienteClase();

    //this.ClaseTemp.codmot =this.inputclase;
    this.ClaseTemp.clase = this.codClase;
    this.ClaseTemp.desclase = this.desClase;
    this.ClaseTemp.codigo = this.codCodigoClase;
    this.ClaseTemp.descodigo = this.desCodigoClase;

    this.clases.push(this.ClaseTemp);
    this.clases = [...this.clases]
    this.modalService.dismissAll();
    console.log("Clase temporal a guardar")
    this.tableclases = this.clases;
    console.log(this.ClaseTemp)
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = null;
    this.desCodigoClase = '';
    this.ClaseTemp = new ClienteClase();
    this.borrarDatosInset();
  }

  open2(content2: string, cla: any) {

    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    console.log("Clase que se modificara")


    console.log(cla)

    this.editinputcla = cla.clase;
    this.editinputdescla = cla.desclase;
    this.obtenerListaClasesCodigos(cla.clase);
    this.editinputcodigo = cla.codigo;
    this.editinputdescodigo = cla.descodigo;
    this.editclase = cla;

    this.modalService.open(content2, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }

  guardarActualizarClase() {
    console.log(this.clases)
    let arreglo = this.clases;
    let indice = arreglo.indexOf(this.editclase)

    console.log(indice)


    arreglo[indice].clase = this.editinputcla;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.editinputcla) {
        this.editinputdescla = element.descri;
      }
    });
    //  
    arreglo[indice].desclase = this.editinputdescla;

    arreglo[indice].codigo = this.editinputcodigo;
    //
    this.listacodigos.forEach(element => {
      if (element.codigo == this.editinputcodigo) {
        console.log(element)
        this.editinputdescodigo = element.descri;
      }
    });
    //
    arreglo[indice].descodigo = this.editinputdescodigo;

    console.log("Arreglos modificado");
    console.log(arreglo)
    this.clases = arreglo
    basicAlert('Se actualizo con éxito.', 'success', 'Aceptar', null, null);
    this.modalService.dismissAll();
  }

  onSelectTipoPersonaIns(codTpe: number) {
    console.log("CODTIPO DE PERSONA");
    console.log(codTpe);

    if (codTpe == 1) {
      this.tident = "06"
    } else {
      this.tident = "999999"
    }
  }
  @ViewChild('dident') dident: ElementRef;

  onSelectTipoIdentidadIns(tipid: string) {
    //evaluando tipo de identidad
    console.log("evaluando tipo de identidad");
    console.log(tipid);
    if (tipid == "01") {
      this.identidad = false
    } else {
      this.identidad = true
      this.objCliente.nrodni = ""
      this.objCliente.nrodni = null;
    }

    this.identidades.forEach(element => {
      if (element.tident == tipid) {
        console.log(element)
        this.tamanoidentidad = element.tamano;
      }
    });

    console.log(this.tamanoidentidad);

    timerOut(50).then((value: any) => {
      if (value) { this.dident.nativeElement.focus(); }
    })
  }

  oneKeyupIdentidad(event: any) {

    if (this.objCliente.tident == "01") {
      this.objCliente.nrodni = this.objCliente.dident;
    }

  }

  onKeyUpNombresCompletos(event: any) {

    this.quitarEspaciosEnBlanco(event.target.value);
    console.log(event.target.value);
    let separacion = event.target.value.replace("  ", " ")

    let NOMBRES = separacion.split(" ");

    if (separacion == '') {
      NOMBRES = [];
    }

    if (NOMBRES.length == 0) {
      this.objCliente.nombres = '';
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
    }

    if (NOMBRES.length == 1) {
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
      this.objCliente.nombres = NOMBRES[0];
    }

    if (NOMBRES.length == 2) {
      this.objCliente.apeliidomaterno = '';
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.nombres = NOMBRES[1];
    }

    if (NOMBRES.length == 3) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2];
    }

    if (NOMBRES.length == 4) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2] + ' ' + NOMBRES[3];
    }
  }
  quitarEspaciosEnBlanco(cadena: string) {
    let espaciosVacios: number = 0;
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena[0];
      if (element == ' ') {
        espaciosVacios = 1;
      }
    }
    //nombresyapellidos
    this.objCliente.nombrescompletos = cadena.replace(cadena.substring(0, espaciosVacios), '');
    if (cadena.includes('  ')) {
      this.objCliente.nombrescompletos = cadena.replace('  ', ' ')
    }
  }

  onBlurDocIdentidad() {
    console.log("this.objCliente.dident.length")
    console.log(this.objCliente.dident.toString().length)


  }

  cerrar(){
    this.modalService2.dismiss('canceling');
  }

  abrirModificar(data) {
    const referenciaModal = this.modalService.open(ModificarClienteComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.codcli = data.codcli;
  }

}
